import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import AdminServiceList from "../../components/AdminService";

const AdminServicePage = (): ReactElement => {
  return (
    <Layout>
      <AdminServiceList />
    </Layout>
  );
};

export default AdminServicePage;
